import { Component, inject, input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { Subscription } from "rxjs";
import { TranslateModule } from "@ngx-translate/core";

type ExecutionResult = stages.management.enactment.ExecutionResult;

@Component({
	selector: "stages-enactment-activator-execution-details",
	templateUrl: "enactment-activator-execution-details.component.html",
	styleUrls: ["./enactment-activator-execution-details.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule],
})
export class EnactmentActivatorExecutionDetailsComponent implements OnInit, OnDestroy {
	private dialog = inject(DialogAdapter);
	private router = inject(Router);

	keys = input.required<{
		executionResult: ExecutionResult;
	}>();

	private routerEventsSubscription?: Subscription;

	ngOnInit(): void {
		this.routerEventsSubscription = this.router.events.subscribe((s) => {
			if (s instanceof NavigationEnd) {
				this.cancel();
			}
		});
	}

	ngOnDestroy(): void {
		if (this.routerEventsSubscription) {
			this.routerEventsSubscription.unsubscribe();
		}
	}

	getStatusMessageKey(): string {
		return "process.enactment.activator.execution.status." + this.keys().executionResult.status;
	}

	cancel(): void {
		this.dialog.close("cancel");
	}
}
